import styled from 'styled-components'

import { Td } from 'components/v2/Table'

export const StyledTd = styled(Td)<{ disabled?: boolean }>`
  ${({ disabled }): string | undefined => {
    if (disabled) {
      return `
        background-color: #F8F9FC!important;
      `
    }
  }}
`

export const Text = styled.span<{ disabled?: boolean }>`
  ${({ disabled }): string | undefined => {
    if (disabled) {
      return `
        color: #B0B0B0;
      `
    }
  }}
`
